// extracted by mini-css-extract-plugin
module.exports = {"iconImg":"index_iconImg__3S950","menuStyle":"index_menuStyle__1N5lG"};